@if (isBrowserMode() && !cookieAgreedFlag && cookieVisible) {
  <div class="cookie-block">
    <div class="container">
      <app-block identifier="cookies_text"></app-block>
      <app-speedy-button
        text="I agree"
        (clicked)="agreeToUseCookies()"
      ></app-speedy-button>
    </div>
    <mat-icon (click)="closeCookieBar()">close</mat-icon>
  </div>
}
